// extracted by mini-css-extract-plugin
export default {"cls1":"OardU3mXJ7YMr8trHaqX","cls2":"BbkmMcEe_a9MEBnPBKTi OardU3mXJ7YMr8trHaqX"};